import React, { Component } from 'react';
import { ComboBox, DropdownSkeleton } from 'carbon-components-react';
import PropTypes from 'prop-types';
import { api } from '../../../helpers/api/api';

export default class InspectionSectionComboBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      items: [],
      value: ''
    };
    this.onChange = this.onChange.bind(this);
  }

  async componentDidMount() {
    this.setState({ loading: true });
    const items = await this.getItems();
    const value= this.props.selectedItem;
    this.setState({ items, loading: false, value});
  }

  onChange = (selectedItem) => {
    const item = selectedItem ? selectedItem.selectedItem : null;
    this.props.onChange(item);
  };

  getItems = async () => {
    let items = [];
   
    try {
      items = (await api.getAll('/inspection/sections')).data;
    } catch (error) {
      this.props.onError(error);
    }
    return items;
  };

  render() {
    return this.state.loading ? (
      <DropdownSkeleton />
    ) : (
      <ComboBox
        id="comboBoxSection"
        disabled={this.state.items < 1 } //|| this.props.disabled
        placeholder="Choose a Section"
        items={this.state.items}
        onChange={this.onChange}
        selectedItem={this.props.selectedItem}
        shouldFilterItem={({ item, inputValue }) =>
          item.name.toLowerCase().includes(inputValue.toLowerCase()) ||
          item.code.toLowerCase().includes(inputValue.toLowerCase())
        }
        invalid={this.props.invalid}
        invalidText={this.props.invalidText}
        itemToString={(item) => (item ? item && item.name : '')}
      />
    );
  }
}

InspectionSectionComboBox.propTypes = {
  invalid: PropTypes.bool,
  invalidText: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  selectedItem: PropTypes.object,
  disabled: PropTypes.bool
};
InspectionSectionComboBox.defaultProps = {
  invalid: false,
  invalidText: '',
  selectedItem: null,
  disabled: true
};
